import { pickSection } from '@convenia/employee-organisms/SystemFields/helpers'
import { PERSONAL_DOCUMENTS_AREA } from '../consts'

const mapSections = (data, key) => {
  if (!Array.isArray(data)) return {}

  const rg = pickSection(data, PERSONAL_DOCUMENTS_AREA.RG, key)
  const driver_license = pickSection(data, PERSONAL_DOCUMENTS_AREA.CNH, key)
  const cpf = pickSection(data, PERSONAL_DOCUMENTS_AREA.CPF, key)
  const reservist = pickSection(data, PERSONAL_DOCUMENTS_AREA.RESERVIST, key)
  const electoral_card = pickSection(data, PERSONAL_DOCUMENTS_AREA.ELECTORAL, key)
  const ctps = pickSection(data, PERSONAL_DOCUMENTS_AREA.CTPS, key)

  const customDocuments = data
    .filter(({ id }) => !Object.values(PERSONAL_DOCUMENTS_AREA).includes(id))
    .reduce((acc, { id, ...section }) => ({ ...acc, [id]: section[key] || {} }), {})

  return {
    rg: rg || {},
    driver_license: driver_license || {},
    cpf: cpf || {},
    reservist: reservist || {},
    electoral_card: electoral_card || {},
    ctps: ctps || {},
    ...customDocuments
  }
}

export const mapSystemFields = (data) => mapSections(data, 'systemFields')

export const mapCustomFields = (data) => {
  return mapSections(data, 'customFields')
}
